import {Injectable} from '@angular/core'
import {environment} from '../../environments/environment'
import {BehaviorSubject, Observable, Subject} from 'rxjs'
import {HttpClient} from '@angular/common/http';
import { ClevertapEventsService } from '../services/clevertap.service';
import { SessionService } from '../services/session.service';
import * as JSZip from 'jszip';
import * as FileSaver from 'file-saver';
import { ToasterService } from 'angular2-toaster';

export interface TalentPoolResponse {
  total: number;
  page: number;
  limit: number;
  list?: (TalentPoolListEntity)[] | null;
}
export interface TalentPoolListEntity {
  id: string;
  userId: string;
  job_offers_id: string;
  created_at: string;
  comment?: null;
  story_url?: null;
  status: string;
  viewed: boolean;
  Curriculum: TalentPoolCurriculum;
  User: TalentPoolUser;
  process_status: string;
  user_score?: number | null;
  other_applications?: (TalentPoolOtherApplicationsEntity)[] | null;
}
export interface TalentPoolCurriculum {
  id: number;
  title: string;
  pages: number;
}
export interface TalentPoolUser {
  id: string;
  name: string;
  surname: string;
  img?: string | null;
  phone: string;
  contact_email: string;
  contact_address: string;
  geolocation?: any;
  Education: TalentPoolEducation;
  created_at: string;
  birth_date: string;
  status?: TalentPoolStatus | null;
}
export interface TalentPoolEducation {
  created_at: string;
  updated_at: string;
  Institute: TalentPoolInstitute;
  StudyTag: TalentPoolStudyTag;
  study_tags_level?: string | null;
}
export interface TalentPoolInstitute {
  id: string;
  name: string;
  location_name: string;
  tag?: string | null;
}
export interface TalentPoolStudyTag {
  id: number;
  tag: string;
  name_en: string;
  name_it: string;
  name_es: string;
  name_fr: string;
  created_at: string;
  updated_at: string;
}
export interface TalentPoolStatus {
  value: string;
  updated_at: string;
}
export interface TalentPoolOtherApplicationsEntity {
  jobOfferId: number;
  position: string;
  curriculum_url: string;
  externalUrl?: null;
  curriculumId: number;
  applicationId: number;
  appliedAt: string;
  tags: string[];
}


@Injectable({
  providedIn: 'root'
})
export class CandidatesService {
  massiveDownload: BehaviorSubject<{label: string; loading: boolean}> = new BehaviorSubject<{label: string; loading: boolean}>({
    label: 'Download',
    loading: false
  });

  massiveDownload$ = this.massiveDownload.asObservable();

  constructor (
    private http: HttpClient,
    private sessionService: SessionService,
    private toasterService: ToasterService
  ) {}

  // (unpaginated)
  getAll(body = {}, page?: number, limit?: number): Observable<any[]> {
    console.log(body, page, limit);
    let url = `${environment.baseUrlWs}${environment.wsVerison}employer/curricula/`;

    if (page >= 0) {
      url += `?page=${page}`;
      if (limit) {
        url += `&size=${limit}`
      }
    }

    return this.http.post<any[]>(url, body)
  }

  getTalentPool(body = {}, page?: number, limit?: number): Observable<TalentPoolResponse> {
    console.log(body, page, limit);
    let url = `${environment.baseUrlWs}${environment.wsVerison}employer/curricula/talent-pool/`;

    if (page >= 0) {
      url += `?page=${page}`;
      if (limit) {
        url += `&limit=${limit}`
      }
    }

    return this.http.post<TalentPoolResponse>(url, body)
  }

  async exportTool(filters: any): Promise <any> {
    const url: string = `${environment.baseUrlWs}${environment.wsVerison}employer/curricula/export-pool`;
    const response = await this.http.post(url, filters, { responseType: 'blob' }).toPromise();
    return response;
  }

  getTagsList(): Observable<any> {
    const url = `${environment.baseUrlWs}${environment.wsVerison}employer/tags-list`;

    return this.http.get(url) as Observable<any>;
  }

  getCandidatesFromFilters(params): Observable<any[]> {
    const normalizedParams = {};
    for (const i in params) {
      if (params.hasOwnProperty(i) && params[i]) {
        let np = params[i];
        if (params[i].value) {
          np = params[i].value
        }
        normalizedParams[i] = np;
      }
    }
    return this.http.get<any[]>(
      environment.baseUrlWs + environment.wsVerison + 'employer/curricula/all/?status=' + normalizedParams['status'] +
      (normalizedParams['username'] ? '&username=' + normalizedParams['username'] : '') +
      (normalizedParams['job_offers_id'] ? '&job_offers_id=' + normalizedParams['job_offers_id'] : '') +
      (normalizedParams['university'] ? '&university=' + normalizedParams['university'] : '') +
      (normalizedParams['skill'] ? '&skill=' + normalizedParams['skill'] : '') +
      (normalizedParams['city'] ? '&city=' + normalizedParams['city'] : '') +
      (normalizedParams['vote'] ? '&vote=' + normalizedParams['vote'] : '') +
      (normalizedParams['faculty_tag'] ? '&faculty_tag=' + normalizedParams['faculty_tag'] : '') +
      (normalizedParams['language'] ? '&language=' + normalizedParams['language'] : '') +
      (normalizedParams['language_level'] ? '&language_level=' + normalizedParams['language_level'] : '')
    )
  }

  openCurriculaFromFilters(params): Observable<string> {
    const options = { responseType: 'text' as 'json' };
    const normalizedParams = {};
    for (const i in params) {
      if (params.hasOwnProperty(i) && params[i]) {
        let np = params[i];
        if (params[i].value) {
          np = params[i].value
        }
        normalizedParams[i] = np;
      }
    }
    return this.http.get<string>(
      environment.baseUrlWs + environment.wsVerison + 'employer/curricula/open-cv-list/?status=' + normalizedParams['status'] +
      (normalizedParams['username'] ? '&username=' + normalizedParams['username'] : '') +
      (normalizedParams['job_offers_id'] ? '&job_offers_id=' + normalizedParams['job_offers_id'] : '') +
      (normalizedParams['university'] ? '&university=' + normalizedParams['university'] : '') +
      (normalizedParams['skill'] ? '&skill=' + normalizedParams['skill'] : '') +
      (normalizedParams['city'] ? '&city=' + normalizedParams['city'] : '') +
      (normalizedParams['vote'] ? '&vote=' + normalizedParams['vote'] : '') +
      (normalizedParams['faculty_tag'] ? '&faculty_tag=' + normalizedParams['faculty_tag'] : '') +
      (normalizedParams['language'] ? '&language=' + normalizedParams['language'] : '') +
      (normalizedParams['language_level'] ? '&language_level=' + normalizedParams['language_level'] : ''),
      options
    )
  }

  downloadPdf(id: number): Observable<any> {
    return this.http.get(`${environment.baseUrlApiAppUsers}employer/user/${id}/print?language=it`, { responseType: 'arraybuffer' as 'json' });
  }

  async downloadMassive() {
    return new Promise(async (resolve, reject) => {
      this.massiveDownload.next({
        loading: true,
        label: 'Preparing ...'
      });
      let stored = this.sessionService.get('candidates_filters') ? JSON.parse(this.sessionService.get('candidates_filters')) : {};
  
      let sanitizedFilters = JSON.parse(JSON.stringify(stored));
      if(sanitizedFilters['job_offers_id']){ sanitizedFilters['job_offers_id'] = sanitizedFilters['job_offers_id'].value; }
      if(sanitizedFilters['languages_id']){ sanitizedFilters['languages_id'] = Number(sanitizedFilters['languages_id'].value); }
      if(sanitizedFilters['language_level']){ sanitizedFilters['language_level'] = Number(sanitizedFilters['language_level'].value); }
      if(sanitizedFilters['cities_ids'] && sanitizedFilters['cities_ids'][0]){ sanitizedFilters['cities_ids'][0] = sanitizedFilters['cities_ids'][0].id; }
      if(sanitizedFilters['universities_ids'] && sanitizedFilters['universities_ids'][0]){ sanitizedFilters['universities_ids'][0] = sanitizedFilters['universities_ids'][0].id; }
      if(sanitizedFilters['faculty_tags'] && sanitizedFilters['faculty_tags'][0]){ sanitizedFilters['faculty_tags'][0] = sanitizedFilters['faculty_tags'][0].id; }
      if(sanitizedFilters['tags_ids'] && sanitizedFilters['tags_ids'][0]) { 
        sanitizedFilters['tags_ids'][0] = sanitizedFilters['tags_ids'][0].id;
      } else {
        delete sanitizedFilters['tags_ids'];
      }
      if(sanitizedFilters['skills_ids'] && sanitizedFilters['skills_ids'][0]){ sanitizedFilters['skills_ids'][0] = sanitizedFilters['skills_ids'][0].id; }
      const candidates: any = await this.getAll(sanitizedFilters, 0, 500).toPromise();
      
      const totCandidates = candidates.rows.length;
      let candidatesId: any[] = [];
  
      ClevertapEventsService.emitEvent('downloadCVs', {total: candidates.rows.length});
  
      candidates.rows.map(c => candidatesId.push({
        call: this.downloadPdf(c.User.id),
        fileName: `${c.User.id}-${c.User.name}-${c.User.surname}`
      }));
  
      let results: any[] = [];
  
      for (const c of candidatesId) {
        const result = await new Promise((resolve, reject) => {
          this.massiveDownload.next({
            label: `Downloading ${results.length + 1} of ${totCandidates} ...`,
            loading: true
          });
          return c.call.toPromise().then(r => resolve(r)).catch(e => resolve(null));
        });
        if (result) {
          results.push({
            file: result,
            fileName: c.fileName
          });
        }
      }
  
      if (results.length > 0) {
        this.massiveDownload.next({
          label: `${totCandidates} downloaded ...`,
          loading: true
        });
        let zip = new JSZip();
        for (let i = 0; i < results.length; i++) {
          zip.file(`${results[i].fileName}.pdf`, new Blob([results[i].file], { type: 'application/pdf' }), { });
        }
  
        this.massiveDownload.next({
          label: `Starting generating Zip File ...`,
          loading: true
        });
        const that = this;
        zip.generateAsync({ type: "blob" })
          .then(function (content) {
            FileSaver.saveAs(content, "pdf-cv-export.zip");
            that.massiveDownload.next({
              label: `Download`,
              loading: false
            });
            resolve(true);
          }).catch(e => {
            that.massiveDownload.next({
              label: `Download`,
              loading: false
            });
            reject();
          });
      }
    });
  }
}
